import { Brands } from '@delta-defense/client-environments';
import { CabelasProductIds } from '../core/enums/levels';
import type { Subscription } from '../core/models/module';

export function resolveMemberBrand(memberSubscriptions: Subscription[]): Brands {
	const firstProductId = memberSubscriptions[0]?.attributes.productId;
	const cabelasValues: string[] = Object.values(CabelasProductIds);

	if (cabelasValues.includes(firstProductId)) {
		return Brands.CabelasShield;
	} else {
		return Brands.USCCA;
	}
}
